import { createRouterItem, RouterItemType } from '@router/routerItem'
import InterestEarnedEvent from '@pages/Event/security/samsung/InterestEarnedEvent'
import TermsPage from '@pages/Event/security/TermsPage'

const PageItems = [
  {
    // 삼성 이자 이벤트
    name: 'samsung_interest_earned',
    path: '/event/security/samsung_interest_earned',
    component: () => InterestEarnedEvent('production'),
  },
  {
    // 삼성 이자 이벤트 개발 서버 테스트용 path
    name: 'samsung_interest_earned_test',
    path: '/event/security/test/samsung_interest_earned',
    component: () => InterestEarnedEvent('staging'),
  },
  {
    // 개인정보 수집 및 제공 동의 상세 페이지
    // type : privacy || thirdParty
    name: 'terms_page',
    path: '/event/security/terms/:type',
    component: TermsPage,
  },
]
const CreatedSecurityEventPageList = PageItems.map(
  ({ path, component, name }) =>
    createRouterItem({
      name,
      path,
      component,
      type: RouterItemType.DEFAULT,
      exact: true,
    })
)
export default CreatedSecurityEventPageList
